import styled from "styled-components";
import TextField from "./TextField";
import * as React from "react";

const ButtonTextFieldInput = styled(TextField)`
  &&& {
    height: 34px;
    border-radius: 4px 0px 0px 4px !important;
  }
`;

const InputGroupDiv = styled.div`
  // bootstrap adds a 2 z-index to these for some reason, but we probably don't want/need that for this component
  .form-control {
    z-index: unset !important;
  }
  .input-group-btn > .btn {
    z-index: unset !important;
  }
`;

interface TextInputWithButtonProps {
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onButtonClick: () => void;
  buttonText: React.ReactNode;
}

function TextInputWithButton({
  placeholder,
  value,
  onChange,
  onButtonClick,
  buttonText,
}: TextInputWithButtonProps) {
  return (
    <InputGroupDiv className="input-group">
      <ButtonTextFieldInput
        className="form-control"
        placeholder={placeholder}
        type="text"
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e)}
      />
      <span className="input-group-btn">
        <button
          className="btn btn-default"
          type="button"
          onClick={onButtonClick}
        >
          {buttonText}
        </button>
      </span>
    </InputGroupDiv>
  );
}

export default TextInputWithButton;



// WEBPACK FOOTER //
// ./app/javascript/components/core/TextInputWithButton.tsx